import clsx from "clsx";

export function LoadingSpinnerFullContainer(
	props: React.HTMLProps<HTMLDivElement>,
) {
	const { className, ...rest } = props;
	return (
		<div
			className={clsx(
				"flex justify-center items-center w-full h-full",
				className,
			)}
			{...rest}
		>
			<LoadingSpinner />
		</div>
	);
}

export function FullContainer(props: React.HTMLProps<HTMLDivElement>) {
	const { className, children, ...rest } = props;
	return (
		<div
			className={clsx(
				"flex justify-center items-center w-full h-full",
				className,
			)}
			{...rest}
		>
			{children}
		</div>
	);
}

export function LoadingSpinner(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width={16}
			height={16}
			viewBox="0 0 16 16"
			style={{ color: "grey" }}
			{...props}
		>
			<g strokeWidth={2} fill="none" fillRule="evenodd">
				<circle
					strokeOpacity={0.25}
					cx={8}
					cy={8}
					r={7}
					stroke="currentColor"
				/>
				<path
					strokeLinecap="round"
					d="M15 8c0-4.5-4.5-7-7-7"
					stroke="currentColor"
				>
					<animateTransform
						attributeName="transform"
						type="rotate"
						from="0 8 8"
						to="360 8 8"
						dur="1s"
						repeatCount="indefinite"
					/>
				</path>
			</g>
		</svg>
	);
}
